import React, { useCallback, useEffect, useMemo, useState } from "react";
import BhavHeader from "../../../components/import/bhav/BhavHeader.jsx";
import Breadcrumbs from "../../../components/ui/Breadcrumbs.jsx";
import BhavConfig from "./BhavConfig.jsx";
import axios from "axios";
import { errorNotify } from "../../../Services/Notification.js";
import RadioButton from "../../../components/ui/RadioButton.jsx";

const getBhavSummaryAPIURL = `${process.env.REACT_APP_API_URL}api/bhav-data-summary/`;
const NCDEX_SRC = "NCD";

const Bhav = () => {
  const [summary, setSummary] = useState({ bhav: [], mcx: [] });
  const [filter, setFilter] = useState();
  const [loading, setLoading] = useState();
  const [filterByCheck, setFilterByCheck] = useState("cm_cd_fo");

  // API CONFIG
  const headers = {
    Authorization: `Bearer ${
      sessionStorage.getItem("subscriberToken")
        ? sessionStorage.getItem("subscriberToken")
        : sessionStorage.getItem("token")
    }`,
    "Content-Type": "application/json",
  };

  const getBhavData = async () => {
    setLoading(true);
    try {
      if (filter?.bookclose_recorddate && filter?.nse_exdate) {
        const payload = {
          start_date: filter?.bookclose_recorddate,
          end_date: filter?.nse_exdate,
        };
        const res = await axios.post(getBhavSummaryAPIURL, payload, {
          headers,
        });

        if (!res.data.error) {
          setSummary({
            bhav: res.data?.bhav?.rows ?? [],
            mcx: (res.data?.bhav_mcx?.rows ?? []).map((item) => ({
              ...item,
              segment: "MCX",
              src: "MCX",
            })),
          });
        } else {
          errorNotify(res.data.message);
        }
      } else if (filter?.bookclose_recorddate && !filter?.nse_exdate) {
        errorNotify("Please select end date");
      } else if (!filter?.bookclose_recorddate && filter?.nse_exdate) {
        errorNotify("Please select start date");
      } else if (!filter?.bookclose_recorddate && !filter?.nse_exdate) {
        errorNotify("Please select start and end date");
      }
      setLoading(false);
    } catch (err) {
      errorNotify("Something went wrong");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (filter?.bookclose_recorddate || filter?.nse_exdate) {
      getBhavData();
    } else if (!filter) {
      setSummary({ bhav: [], mcx: [] });
      setLoading(false);
    }
  }, [filter?.bookclose_recorddate, filter?.nse_exdate]);

  const data = useMemo(() => {
    if (filterByCheck === "mcx") return summary.mcx;
    if (filterByCheck === "ncdex")
      return summary.bhav.filter((item) => item.src === NCDEX_SRC);
    return summary.bhav.filter((item) => item.src !== NCDEX_SRC);
  }, [summary, filterByCheck]);

  const handleTimeChange = useCallback((value) => {
    setFilterByCheck(value);
  }, []);

  const breadcrumbs = ["Home", "Import", "Bhav"];

  return (
    <div className=" app-container min-h-[65vh] pb-[60px] pt-[100px]">
      <div className="flex justify-between">
        <Breadcrumbs items={breadcrumbs} />
        <div className="flex gap-4">
          <RadioButton
            label="CM, CD, FO"
            value="cm_cd_fo"
            checked={filterByCheck === "cm_cd_fo"}
            onChange={handleTimeChange}
          />
          <RadioButton
            label="MCX"
            value="mcx"
            checked={filterByCheck === "mcx"}
            onChange={handleTimeChange}
          />
          <RadioButton
            label="NCDEX"
            value="ncdex"
            checked={filterByCheck === "ncdex"}
            onChange={handleTimeChange}
          />
        </div>
      </div>

      <BhavHeader setFilter={setFilter} />
      <BhavConfig tableData={data} loading={loading} />
    </div>
  );
};

export default Bhav;
